import React, { useState } from "react";
import {
  Abc,
  DateRange,
  DoubleArrow,
  Edit,
  Forward5,
  Timelapse,
} from "@mui/icons-material";
import { tooltipStyleProps } from "services/constants/Styles";
import { Tooltip, Drawer } from "@mui/material";
import { showToast } from "services/utils/Status";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import { UserDetailsRow } from "components/CustomComponents/UserDetailsRow";
import { useForm } from "react-hook-form";
import { EditPreApproval } from "./EditPreApproval";
import { customAPI } from "services/utils/CustomAPI";
import { CustomTextBox } from "components/CustomComponents";
import {
  unSavedText,
  unSavedMessage,
  drawerStyle,
  editIconStyle,
  doubleArrowStyle,
  parentBoxStyle,
  childBoxStyleSpaceBetween,
} from "services/constants";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Card,
  Grid,
  Avatar,
  CardContent,
} from "@mui/material";
import { toAlignEnd } from "services/constants";
import { CustomButtonWithBorder } from "components/CustomComponents/CustomButton";
import { CustomButton } from "components/CustomComponents";
import { useSelector } from "react-redux";

export const ViewPreApproval = ({
  onClose,
  preApprovalData,
  reCallApi,
  setGetId,
  setHandleLoader,
  screenAccess,
}) => {
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const { domain } = useSelector((state) => state.tokenReducer);
  const { reset, setValue, handleSubmit, watch, register } = useForm({
    mode: "onBlur",
    button_loader: false,
    is_reject_clicked: false,
  });

  const cardData = [
    {
      id: 1,
      label: "Overtime Date",
      value: preApprovalData?.ot_date ?? "N/A",
      icon: DateRange,
      variant: "blue",
    },
    {
      id: 2,
      label: "Duration in hrs",
      value: preApprovalData?.ot_duration ?? "N/A",
      icon: Timelapse,
      variant: "red",
    },
    {
      id: 3,
      label: "Applicable Timing",
      value: preApprovalData?.ot_consideration ?? "N/A",
      icon: Forward5,
      variant: "grey",
    },
    {
      id: 4,
      label: "Reason",
      value: preApprovalData?.reason ?? "N/A",
      icon: Abc,
      variant: "purple",
    },
  ];

  const hanldeEditPanel = () => {
    setIsEditPanelOpen(true);
  };

  const handleClosePanel = () => {
    if (hasUnsavedChanges) {
      setShowConfirmationDialog(true);
    } else {
      setIsEditPanelOpen(false);
    }
  };

  const handleConfirmClose = () => {
    setShowConfirmationDialog(false);
    setIsEditPanelOpen(false);
  };

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
    reset();
  };

  const onSubmit = async () => {
    setValue("button_loader", true);
    const payload = {
      ot_ids: [preApprovalData?.id],
      ot_date: preApprovalData?.ot_date.split("-").reverse().join("-"),
      ot_duration: preApprovalData?.ot_duration,
      ot_consideration: preApprovalData?.ot_consideration,
      status: watch("is_reject_clicked") ? "Rejected" : "Approved",
      ...(watch("is_reject_clicked")
        ? { rejected_reason: watch("reason") }
        : { reason: preApprovalData?.reason }),
    };

    const response = await customAPI(
      `${domain}Team_Zone/Approve/Over_time/ot-pre-approve/`,
      "PUT",
      payload
    );
    if (response.ok) {
      showToast(
        watch("is_reject_clicked") ? "error" : "success",
        response?.responseDetails?.message
      );
      onClose();
      setValue("is_reject_clicked", false);
      setValue("button_loader", false);
      setGetId(preApprovalData?.id);
      setHandleLoader(false);
      reCallApi(true);
    } else {
      setValue("button_loader", false);
      showToast("error", response?.message);
    }
  };

  const handleReason = (event) => {
    const reason = event.target.value;
    if (reason) {
      setValue("reason", event.target.value);
    } else {
      setValue("reason", "");
    }
  };

  return (
    <>
      <Box sx={parentBoxStyle}>
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelClose}
          onConfirm={
            watch("is_reject_clicked")
              ? handleSubmit(onSubmit)
              : handleConfirmClose
          }
          title={watch("is_reject_clicked") ? "Reason" : unSavedText}
          message={watch("is_reject_clicked") ? "" : unSavedMessage}
          confirmText={watch("is_reject_clicked") ? "Reject" : "Exit"}
          cancelText="Cancel"
          showChildren={watch("is_reject_clicked")}
        >
          <Box sx={{ mb: 1 }}>
            <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
              Reason (Optional)
            </Typography>

            <CustomTextBox
              type="multiline"
              rules={{
                ...register("reason", {
                  required: false,
                }),
              }}
              selectedValue={watch("reason")}
              updateDataFunction={handleReason}
              placeHolder={"Enter a reason for deletion"}
            />
          </Box>
        </ConfirmationDialog>

        <Paper elevation={0} sx={{ borderRadius: 0 }}>
          <Box>
            <Box sx={childBoxStyleSpaceBetween}>
              <IconButton onClick={onClose} sx={doubleArrowStyle}>
                <DoubleArrow />
              </IconButton>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Tooltip title="Edit" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        hanldeEditPanel();
                        setValue("is_reject_clicked", false);
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to edit payrun cycle`
                        );
                      }
                    }}
                    sx={editIconStyle}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                View OT Pre-Approval Request
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Overtime Request Details
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <UserDetailsRow
            userDetails={{
              image_url: preApprovalData?.image_url,
              employee_id: preApprovalData?.employee_id,
              user_name: preApprovalData?.employee_name,
              department_name: preApprovalData?.department,
              designation: preApprovalData?.designation,
            }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 3,
              mt: 4,
              mb: 2,
            }}
          >
            <Grid container spacing={{ xs: 4, md: 6 }}>
              {cardData.map((item) => {
                const IconComponent = item.icon;
                const isBlue = item.variant === "blue";

                return (
                  <Grid item xs={12} sm={12} key={item.id}>
                    <Card
                      sx={{
                        bgcolor: "#3c73e70d",
                        borderRadius: "5px",
                        border: 0,
                        boxShadow: "0px 4px 4px #00000040",
                      }}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                            mb: 2,
                          }}
                        >
                          <Avatar
                            variant="rounded"
                            sx={{
                              width: 35,
                              height: 35,
                              bgcolor: isBlue ? "#3c73e71a" : "#bd09091a",
                              border: `0.5px solid ${item?.variant}`,
                              boxShadow: "0px 1px 2px #00000040",
                              color: item?.variant,
                            }}
                          >
                            <IconComponent
                              size={18}
                              color={isBlue ? "#3c73e7" : "#d71515"}
                            />
                          </Avatar>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              mb: "auto",
                            }}
                          >
                            {item.label}
                          </Typography>
                        </Box>
                        <Box sx={{ pl: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 700,
                              color: "#32325D",
                            }}
                          >
                            {item.value}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
          {preApprovalData?.status === "Pending" && (
            <Box sx={toAlignEnd}>
              <CustomButtonWithBorder
                actionName="Reject"
                typeName="button"
                handleColor={true}
                actionFuntion={() => {
                  setShowConfirmationDialog(true);
                  setValue("is_reject_clicked", true);
                }}
              />
              <CustomButton
                actionFuntion={handleSubmit(onSubmit)}
                actionName="Approve"
                typeName="submit"
                disableAction={watch("button_loader")}
              />
            </Box>
          )}
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={isEditPanelOpen}
        onClose={() => {
          handleClosePanel();
        }}
        sx={drawerStyle}
      >
        <EditPreApproval
          onClose={handleClosePanel}
          preApprovalData={preApprovalData}
          reCallApi={reCallApi}
          setGetId={setGetId}
          setIsEditPanelOpen={setIsEditPanelOpen}
          setHandleLoader={setHandleLoader}
          setHasUnsavedChanges={setHasUnsavedChanges}
        />
        <></>
      </Drawer>
    </>
  );
};
